import { render, staticRenderFns } from "./NiceCard.vue?vue&type=template&id=55491cd3&scoped=true&"
import script from "./NiceCard.vue?vue&type=script&lang=js&"
export * from "./NiceCard.vue?vue&type=script&lang=js&"
import style0 from "./NiceCard.vue?vue&type=style&index=0&id=55491cd3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55491cd3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VDivider,VFlex,VIcon,VLayout})
